import React, {Component} from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context"
import {FormattedMessage, FormattedDate, FormattedTime} from 'react-intl'
import moment from 'moment'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css';
import Icon from "../../../../common/icon/icon.component.jsx"
import LoadingSpinner from "../../../../common/spinner/loading.component.jsx"
const uuidv4 = require('uuid/v4')

class BookingEventSection extends Component {

    constructor(props, context) {
        super(props, context)
        const tomorrow = new Date()
        tomorrow.setDate(new Date().getDate()+1)
        this.state = {
            section: this.props.section || null,
            product: this.props.product || null,
            variables: this.props.variables || null,
            isPdf: this.props.isPdf || false,
            isLast: this.props.isLast === true,
            itemId: this.props.itemId || '',
            productId: this.props.productId || '',
            focused: false,
            date: tomorrow,
            options: [],
            loading: false,
            showDatePicker: false,
        }
        this.previous = this.previous.bind(this)
        this.next = this.next.bind(this)
        this.toggleDatePicker = this.toggleDatePicker.bind(this)
    }

    componentDidMount() {
        this.refresh()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            variables: nextProps.variables || null,
            section: nextProps.section || null,
            isPdf: nextProps.isPdf || false,
            productId: nextProps.productId || '',
            itemId: nextProps.itemId || '',
        }, () => {
            this.refresh()
        })
    }

    pad(n, width, z) {
        z = z || '0'
        n = n + ''
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    }

    getFormattedDate(date) {
        return date.getUTCFullYear() + "-" +
            this.pad(date.getUTCMonth()+1, 2) + "-" +
            this.pad(date.getUTCDate(), 2) + "T" +
            this.pad(date.getUTCHours(), 2) + ":" +
            this.pad(date.getUTCMinutes(), 2) + ":" +
            this.pad(date.getUTCSeconds(), 2)
    }

    getFromDate() {
        const date = new Date(this.state.date)
        date.setHours(0)
        date.setMinutes(0)
        date.setSeconds(0)
        return this.getFormattedDate(date)
    }

    getToDate() {
        const date = new Date(this.state.date)
        date.setHours(23)
        date.setMinutes(59)
        date.setSeconds(59)
        return this.getFormattedDate(date)
    }

    isToday() {
        return moment(new Date()).isSame(this.state.date, 'day')
    }

    next(e) {
        e.preventDefault()
        let nbDay = 1
        if (this.state.date.getDay() === 5) {
            nbDay = 3
        }
        const next = moment(this.state.date)
        next.add(nbDay, 'd')
        this.setState({
            date: next.toDate()
        }, this.refresh)
    }

    previous(e) {
        e.preventDefault()
        let nbDay = 1
        if (this.state.date.getDay() === 1) {
            nbDay = 3
        }
        const previous = moment(this.state.date)
        previous.subtract(nbDay, 'd')
        this.setState({
            date: previous.toDate()
        }, this.refresh)
    }

    refresh() {
        this.setState({
            loading: true
        })
        AppContext.getApiClient().setAccountId(this.state.variables.quote.accountId)
        AppContext.getApiClient().put('/proposals/' + this.state.variables.hash + '/products/' +this.state.productId+ '/event-times', {
            interval: 30 * 60 * 1000 * 1000 * 1000,
            from: this.getFromDate(),
            to: this.getToDate(),
        }).then(res => {
            this.setState({
                loading: false,
                options: res.data.map(a => {
                        return {
                            organizerId: a.attributes.organizerId,
                            date: new Date(a.attributes.date),
                        }
                    }).filter(d => d.date.getHours() > 7 && d.date.getHours() < 17),
            })
        })
    }

    book(date, organizerId) {
        return function (e) {
            e.preventDefault()
            this.setState({
                loading: true
            })
            AppContext.getApiClient().setAccountId(this.state.variables.quote.accountId)
            AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/events', {
                date: this.getFormattedDate(date),
                organizerId: organizerId,
                itemId: this.state.itemId,
                attendeeName: this.state.variables.customer.name,
                attendeeEmail: this.state.variables.customer.email,
            }).then(res => {
                const variables = this.state.variables
                variables.booking.events.push(res)
                this.setState({
                    variables: variables,
                    loading: false,
                })
            })
        }.bind(this)

    }

    toggleDatePicker(e) {
        e.preventDefault()
        this.setState({
            showDatePicker: !this.state.showDatePicker
        })
    }

    getBooking() {
        return this.state.variables.booking.events.filter(i => i.attributes.itemId === this.state.itemId)[0]
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        const booking = this.getBooking()
        const hide = this.state.showDatePicker && !booking ? "d-flex" : "d-none"

        let options = this.state.options.map((o, key) => {
            return <div key={key} className={"row justify-content-center"}>
                <p className={"col-md-10"}>
                    <button className={"btn btn-outline-primary w-100"} onClick={this.book(o.date, o.organizerId)}>
                        <FormattedTime value={o.date}/>
                    </button>
                </p>
            </div>
        })
        if (options.length === 0) {
            options = <div className={"row justify-content-center"}>
                <p className={"col-md-10 py-2 mb-0"}>
                    <FormattedMessage
                        id="proposal.no_time_available_message"
                        defaultMessage="No time available this day"
                    />
                </p>
            </div>
        }

        return <div className="row">
            <div className="col-12 text-center">
                <div className={"row"}>
                    <div className={"col-12 text-left"}>
                        <h5 className={"py-3 mb-0 " + (this.state.isLast ? "" : "border-bottom") }>
                            {this.state.product.title}
                            {booking ? <strong className={"ml-1"}>
                                <FormattedMessage
                                    id="proposal.event_date_label"
                                    defaultMessage="on {date} at {time}"
                                    values={{
                                        date: <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            weekday='long'
                                            value={booking.attributes.from}
                                        />,
                                        time: <FormattedTime value={booking.attributes.from}/>
                                    }}
                                />
                            </strong> : <button className={"ml-3 btn btn-sm btn-primary"} onClick={this.toggleDatePicker}>
                                {!this.state.showDatePicker ? <FormattedMessage
                                    id="proposal.pick_a_date_btn"
                                    defaultMessage="Pick a date"
                                /> : <FormattedMessage
                                    id="proposal.close_pick_a_date_btn"
                                    defaultMessage="Close"
                                />}
                            </button>}
                        </h5>
                    </div>
                </div>
                <div className={"row " + hide}>
                    <div className={"col-12 my-3"}>
                        <SingleDatePicker
                            displayFormat="LL"
                            onDateChange={(date) => {this.setState({date: date.toDate()}, this.refresh)}}
                            focused={this.state.focused}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            date={moment(this.state.date)}
                            numberOfMonths={1}
                            isDayBlocked={day => {
                                return [0, 6].includes(day.day())
                            }}
                            customInputIcon={<Icon value={'calendar-alt'}/>}
                            id={uuidv4()}
                        />
                    </div>
                </div>
                <div className={"row justify-content-center " + hide}>
                    {!this.isToday() ? <div className={"align-self-center"} style={{ fontSize: '2rem'}}>
                        <a href={'#'} onClick={this.previous}>
                            <Icon value={'chevron-left'}/>
                        </a>
                    </div> : ''}
                    <div className={"col-xs-10 col-sm-10 col-md-8 col-lg-6"}>
                        {this.state.loading ? <LoadingSpinner /> : options}
                    </div>
                    <div className={"align-self-center"} style={{ fontSize: '2rem'}}>
                        <a href={'#'} onClick={this.next}>
                            <Icon value={'chevron-right'}/>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    }

}

export default BookingEventSection





// WEBPACK FOOTER //
// ./src/template/sections/content/approve-section/bookingevent.component.jsx